import type {
  ICartStatusResponseDtoData,
  ICompleteCartDtoData,
  ICustomerOrderPositionCommandData
} from '~/dtos/ProdegaApiWebshop-api-typings-generated';
import type {
  CancelCartData,
  CartResponseData,
  ChangeDeliveryDateData,
  MutatePositionPayload,
} from '~/features/cart/state-machine/types';



export type CartApi = {
  fetchCurrentOrder: (frontendOrderId: number | undefined) => Promise<CartResponseData>;
  refreshCurrentOrder: (frontendOrderId: number | undefined) => Promise<CartResponseData>;
  createNewOrder: (desiredDeliveryDate: string) => Promise<CartResponseData>;
  sendCurrentOrder: (completeCartData: ICompleteCartDtoData) => Promise<CartResponseData>;
  cancelCurrentOrder: (cancelCartData: CancelCartData) => Promise<CartResponseData>;
  changeDeliveryDateOfCurrentOrder: (changeDeliveryDateData: ChangeDeliveryDateData) => Promise<CartResponseData>;
  addPosition: (
    orderId: number,
    articleNumber: string,
    quantity: number,
    externalArticle: boolean
  ) => Promise<CartResponseData>;
  removePosition: (positionId: number, externalArticle: boolean) => Promise<CartResponseData>;
  mutatePosition(positionId: number, payload: MutatePositionPayload): Promise<CartResponseData>;
  sendPositonCommands: (positionCommands: ICustomerOrderPositionCommandData[]) => Promise<CartResponseData>;
  copyExistingOrderToCart: (currentOrderId: number, existingOrderId: number) => Promise<CartResponseData>;
  copyTemplateArticleToCart: (
    currentOrderId: number,
    templateId: number,
    selectedMainArticleIds?: number[]
  ) => Promise<CartResponseData>;
  copySalesOrderSetArticleToCart: (
    currentOrderId: number,
    articles: { articleNumber: string; quantity: number }[]
  ) => Promise<CartResponseData>;
  importCsvToCart: (currentOrderId: number, csvData: string) => Promise<CartResponseData>;
  fetchCartStatus: (frontendOrderId: number | undefined) => Promise<ICartStatusResponseDtoData>;
};

// Das API kann erst instanziert werden, wenn der User in den BGH Shop navigiert 
let apiInstance: CartApi | undefined;

export function setApiInstance(api: CartApi | undefined) {
  apiInstance = api;
}
export function api() {
  return apiInstance!;
}
